import { render, staticRenderFns } from "./FashionDetailsIcon.vue?vue&type=template&id=6acb3dec&"
import script from "./FashionDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./FashionDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports